import axios from "axios";
import { getEnhancedAuthHeaders } from "./auth";
const backendUrl = process.env.REACT_APP_BACKEND_URL_FOR_FRONTEND;

// GET
// Get all products with optional company filter
export const getAllProducts = async (companyId = "") => {
  try {
    // Optional company filter
    const url = companyId
      ? `${backendUrl}/products?companyId=${companyId}`
      : `${backendUrl}/products`;

    const products = await axios.get(url, {
      headers: getEnhancedAuthHeaders(),
    });
    return products.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getAllProductTypes = async () => {
  try {
    const productTypes = await axios.get(`${backendUrl}/products/types`, {
      headers: getEnhancedAuthHeaders(),
    });
    return productTypes.data;
  } catch (error) {
    throw new Error(error.message);
  }
};

// POST
// Add a new product
export const addNewProduct = async (product) => {
  try {
    const response = await axios.post(`${backendUrl}/products`, product, {
      headers: getEnhancedAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Add a new base product -- Associate a base with a product
export const associateBaseWithProduct = async (productData) => {
  try {
    const response = await axios.post(
      `${backendUrl}/products/associate-base`,
      productData,
      {
        headers: getEnhancedAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.message);
  }
};

// PUT/PATCH
// Update an existing product
export const updateProduct = async (productId, productData) => {
  try {
    const response = await axios.put(
      `${backendUrl}/products/${productId}`,
      productData,
      {
        headers: getEnhancedAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.message);
  }
};

// DELETE
// Hard delete a product by ID
export const deleteProduct = async (productId) => {
  console.log("Deleting product with ID:", productId);
  try {
    const response = await axios.delete(`${backendUrl}/products/${productId}`, {
      headers: getEnhancedAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.error || error.message);
  }
};
